import { render, staticRenderFns } from "./StageItem.vue?vue&type=template&id=0bd4f034&scoped=true"
import script from "./StageItem.vue?vue&type=script&lang=js"
export * from "./StageItem.vue?vue&type=script&lang=js"
import style0 from "./StageItem.vue?vue&type=style&index=0&id=0bd4f034&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd4f034",
  null
  
)

export default component.exports